module.exports = __webpack_public_path__ + "24507403c2effc1bf127c564d6c19c3e.pdf";